import React, { useEffect, useState } from 'react'
import { Table, Empty } from 'antd'
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next';

interface IDragSortingTable {
  form: any,
  data: any[]
  headers: Array<{
    key: string
    title: string
    filterable?: boolean
    render?: (text: any, record: any, index: number) => React.ReactNode
  }>
  setSigners: any
}

export const DragSortingTable: React.FC<IDragSortingTable> = ({
  form,
  data = [],
  headers = [],
  setSigners
}) => {
  const { t } = useTranslation()
  const [state, setState] = useState<any>({
    data
  })

  const ordered_signers = form.getFieldValue('ordered_signers') || form.getFieldValue('ordered_signers_multiple')

  useEffect(() => {
    setState({ data })
  }, [data])

  useEffect(() => {
    setSigners(state.data)
  }, [state])

  let dragingIndex = -1;

  const BodyRow = (props: any) => {
    const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = props
    const style = { ...restProps.style, cursor: 'move' }

    let { className } = restProps;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward'
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward'
      }
    }

    return connectDragSource(
      connectDropTarget(<tr {...restProps} className={className} style={style} />),
    );
  }

  const rowSource = {
    beginDrag(props: any) {
      dragingIndex = props.index
      return {
        index: props.index,
      };
    },
  };

  const rowTarget = {
    drop(props: any, monitor: any) {
      const dragIndex = monitor.getItem().index
      const hoverIndex = props.index
  
      if (dragIndex === hoverIndex) {
        return;
      }
      props.moveRow(dragIndex, hoverIndex)
  
      monitor.getItem().index = hoverIndex
    },
  };

  const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }))(
    DragSource('row', rowSource, connect => ({
      connectDragSource: connect.dragSource(),
    }))(BodyRow),
  );

  const moveRow = (dragIndex: any, hoverIndex: any) => {
    const { data } = state
    const dragRow = data[dragIndex]

    setState(
      update(state, {
        data: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
        },
      }),
    )
  }

  const components = {
    body: {
      row: DragableBodyRow,
    },
  };

  const locale = {
    emptyText: (
      <span>
        <p>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE} 
            description={
              <span >
                {t('signature.newDocument.stepsForm.signersMultipleInput.noDataTable')}
              </span>
            }
          />
        </p>
      </span>
    )
  };

  return (
    <React.Fragment>
      {
        ordered_signers ? (
          <DndProvider backend={HTML5Backend}>
            <Table
              className={styles.table}
              locale={locale}
              columns={headers}
              dataSource={state.data}
              components={components}
              onRow={(_, index) => ({
                index,
                moveRow: moveRow,
              })}
              scroll={{ x: 'max-content' }}
            />
          </DndProvider>
        ) : (
          <Table
            className={styles.table}
            locale={locale}
            columns={headers}
            dataSource={state.data}
            scroll={{ x: 'max-content' }}
          />
        )
      }
    </React.Fragment>
  )
}
